import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert.component';
import { ProblemAlertComponent } from './problem-alert.component';

@NgModule({
  declarations: [AlertComponent, ProblemAlertComponent],
  imports: [CommonModule],
  exports: [AlertComponent, ProblemAlertComponent],
})
export class AlertModule {}
